import { render, staticRenderFns } from "./RadioFeatureField.vue?vue&type=template&id=20789d06&"
import script from "./RadioFeatureField.vue?vue&type=script&lang=js&"
export * from "./RadioFeatureField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports